import { IUserSeriesDetail, v1UserSeriesDetailsGet } from '@ifit/gateway-wolf-dashboard-service';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { FIFTEEN_SECONDS, ONE_DAY } from '../../util/durations';
import { isClub } from '../../util/is-club';
import { useSoftwareNumber } from '../selectors/use-software-number';
import { useUserId } from '../selectors/use-user-id';
import { useLanguage } from '../selectors/use-language';

export function useUserSeriesDetails(seriesIds: string[]): UseQueryResult<IUserSeriesDetail[], Error> {
  const softwareNumber = useSoftwareNumber();
  const isClubMachine = isClub(softwareNumber);
  const userId = useUserId();
  const language = useLanguage();

  const queryOptions: UseQueryOptions<IUserSeriesDetail[], Error> = {
    staleTime: FIFTEEN_SECONDS,
    cacheTime: ONE_DAY,
    enabled: Boolean(userId && seriesIds && seriesIds.length > 0),
  };

  if (!userId) {
    queryOptions.initialData = seriesIds?.map((id) => {
      return {
        seriesId: id,
        locked: true,
        completedDate: null,
      };
    });
  }

  return useQuery<IUserSeriesDetail[], Error>(
    ['user-series-details', { userId, isClubMachine, seriesIds, language }],
    () =>
      v1UserSeriesDetailsGet({
        seriesIds,
        softwareNumber: Number(softwareNumber),
        isClub: isClubMachine,
        headers: { language },
      }),
    queryOptions
  );
}
